import { toCSSPixel } from '../../utils/styles'

import { USE_RESIZABLE_DIRECTION } from './useResizable.constants'

function isUseResizableDirectionHorizontal(direction) {
  return direction === USE_RESIZABLE_DIRECTION.Horizontal
}

export function getComputedStyles(node) {
  const styles = window.getComputedStyle(node)

  const width = parseInt(styles.width, 10)
  const minWidth = parseInt(styles.minWidth, 10)
  const height = parseInt(styles.height, 10)
  const minHeight = parseInt(styles.minHeight, 10)

  return { height, minHeight, minWidth, width }
}

export function applyNextStyles({ direction, nextHeight, nextWidth, node }) {
  isUseResizableDirectionHorizontal(direction)
    ? (node.style.width = toCSSPixel(nextWidth))
    : (node.style.height = toCSSPixel(nextHeight))
}
